export const CONTACT_CHANNELS = {
  WHATSAPP: 'whatsapp',
  CALENDLY: 'calendly',
  EMAIL: 'email',
  FORM: 'form',
};

export const CTA_LOCATIONS = {
  HEADER: 'header',
  MOBILE_MENU: 'mobile_menu',
  HERO: 'hero',
  BENTO: 'bento',
  FAQ: 'faq',
  FOOTER: 'footer',
  FLOATING: 'floating',
  MODEL_CARD: 'model_card',
  PAGE_CTA: 'page_cta',
  DECK_CLOSE: 'deck_close',
  FORM_SUCCESS: 'form_success',
};

export const CTA_IDS = {
  HEADER_WHATSAPP: 'header_whatsapp',
  MOBILE_MENU_WHATSAPP: 'mobile_menu_whatsapp',
  HERO_WHATSAPP: 'hero_whatsapp',
  FAQ_WHATSAPP: 'faq_whatsapp',
  FLOATING_WHATSAPP: 'floating_whatsapp',
  FOOTER_WHATSAPP: 'footer_whatsapp',
  IA_HERO_WHATSAPP: 'ia_hero_whatsapp',
  IA_MID_WHATSAPP: 'ia_mid_whatsapp',
  IA_FINAL_WHATSAPP: 'ia_final_whatsapp',
  IA_AGENDAR: 'ia_agendar',
  MODEL_CARD_WHATSAPP: 'model_card_whatsapp',
  HERO_CALENDLY: 'hero_calendly',
  FOOTER_CALENDLY_PRIMARY: 'footer_calendly_primary',
  FOOTER_CALENDLY_NAV: 'footer_calendly_nav',
  CAPACIDADES_HERO_CALENDLY: 'capacidades_hero_calendly',
  CAPACIDADES_FOOTER_CALENDLY: 'capacidades_footer_calendly',
  MODELOS_CALENDLY: 'modelos_calendly',
  DECK_CLOSE_CALENDLY: 'deck_close_calendly',
  AGENDAR_PRIMARY_CALENDLY: 'agendar_primary_calendly',
  AGENDAR_FALLBACK_CALENDLY: 'agendar_fallback_calendly',
  PROJECTS_AGENDAR: 'projects_agendar',
  PROJECT_DETAILS_AGENDAR: 'project_details_agendar',
  TEAM_AGENDAR: 'team_agendar',
  FOOTER_EMAIL: 'footer_email',
  DECK_CLOSE_EMAIL: 'deck_close_email',
  DECK_CLOSE_WHATSAPP: 'deck_close_whatsapp',
  IA_CLOSE_EMAIL: 'ia_close_email',
  IA_CLOSE_WHATSAPP: 'ia_close_whatsapp',
  BENTO_IA: 'bento_ia',
  BENTO_WEBS: 'bento_webs',
  BENTO_APPS: 'bento_apps',
  BENTO_PROYECTO: 'bento_proyecto',
  BENTO_PARTNERSHIP: 'bento_partnership',
  BENTO_REVENUE_SHARE: 'bento_revenue_share',
  BENTO_CAPACIDADES: 'bento_capacidades',
  BENTO_MODELOS: 'bento_modelos',
  CAPACIDADES_MODELOS: 'capacidades_modelos',
  CAPACIDADES_IA: 'capacidades_ia',
};

export const WHATSAPP_NUMBER = '595994459583';
export const CALENDLY_URL = 'https://calendly.com/lucas-eientech/discover';
